export const defaultWpMenu = {
  headerMenu: [
    {
      children: [
        {
          id: "menu-item-1347",
          text: "Aer condiționat / Ventilație",
          url: "https://uniprest.ro/categorii-de-produse/aer-conditionat-ventilatie/"
        },
        {
          id: "menu-item-1909",
          text: "Apă",
          url: "https://uniprest.ro/categorii-de-produse/apa/"
        },
        {
          id: "menu-item-2675",
          text: "Energie verde",
          url: "https://uniprest.ro/categorii-de-produse/energie-verde/"
        },
        {
          id: "menu-item-2674",
          text: "Gaz",
          url: "https://uniprest.ro/categorii-de-produse/gaz/"
        },
        {
          id: "menu-item-2673",
          text: "Sanitare",
          url: "https://uniprest.ro/categorii-de-produse/sanitare/"
        },
        {
          id: "menu-item-2672",
          text: "Termice / Încălzire",
          url: "https://uniprest.ro/categorii-de-produse/termice-incalzire/"
        },
        {
          id: "menu-item-2671",
          text: "Noutăți",
          url: "https://uniprest.ro/categorii-de-produse/noutati/"
        }
      ],
      id: "menu-item-2662",
      text: "Categorii de produse",
      url: "https://uniprest.ro/categorii-de-produse/"
    },
    {
      id: "menu-item-129",
      text: "Servicii",
      url: "https://uniprest.ro/servicii/"
    },
    {
      id: "menu-item-1466",
      text: "Promoții",
      url: "https://uniprest.ro/promotii/"
    },
    {
      children: [
        {
          id: "menu-item-270",
          text: "Install Efficiency",
          url: "https://uniprest.ro/evenimente/install-efficiency/"
        },
        {
          children: [
            {
              id: "menu-item-6598",
              text: "EXPO Uniprest BANAT & CRIȘANA",
              url: "https://uniprest.ro/evenimente/expo-uniprest/expo-banat-crisana/"
            },
            {
              id: "menu-item-6599",
              text: "EXPO Uniprest MOLDOVA & BUCOVINA",
              url: "https://uniprest.ro/evenimente/expo-uniprest/expo-moldova-bucovina/"
            },
            {
              id: "menu-item-6597",
              text: "EXPO Uniprest TRANSILVANIA & MARAMUREȘ",
              url: "https://uniprest.ro/evenimente/expo-uniprest/expo-transilvania-maramures/"
            },
            {
              id: "menu-item-6600",
              text: "EXPO Uniprest OLTENIA, MUNTENIA & DOBROGEA",
              url: "https://uniprest.ro/evenimente/expo-uniprest/expo-oltenia-muntenia-dobrogea/"
            },
            {
              id: "menu-item-6596",
              text: "EXPO Uniprest MUREȘ",
              url: "https://uniprest.ro/evenimente/expo-uniprest/expo-uniprest-mures/"
            }
          ],
          id: "menu-item-269",
          text: "EXPO Uniprest",
          url: "https://uniprest.ro/evenimente/expo-uniprest/"
        },
        {
          id: "menu-item-268",
          text: "Conversații-n Instalații",
          url: "https://uniprest.ro/evenimente/conversatii-n-instalatii/"
        }
      ],
      id: "menu-item-2145",
      text: "Evenimente",
      url: "https://uniprest.ro/evenimente/"
    },
    {
      id: "menu-item-4743",
      text: "Uniprest Instal Digital",
      url: "https://uniprest.ro/uniprest-instal-digital/"
    },
    {
      children: [
        {
          id: "menu-item-281",
          text: "Despre Uniprest Instal",
          url: "https://uniprest.ro/despre-noi/despre-uniprest-instal/"
        },
        {
          id: "menu-item-280",
          text: "Cui ne adresăm",
          url: "https://uniprest.ro/despre-noi/cui-ne-adresam/"
        },
        {
          id: "menu-item-9278",
          text: "Partenerii noștri",
          url: "https://uniprest.ro/despre-noi/partenerii-nostri/"
        },
        {
          id: "menu-item-13867",
          text: "Raport Piața de construcții & instalații 2026",
          url: "https://uniprest.ro/raport-piata-de-constructii-instalatii-2026/"
        },
        {
          id: "menu-item-284",
          text: "Uniprest Instal în presă",
          url: "https://uniprest.ro/despre-noi/uniprest-instal-in-presa/"
        },
        {
          id: "menu-item-282",
          text: "Implicare socială",
          url: "https://uniprest.ro/despre-noi/implicare-sociala/"
        },
        {
          id: "menu-item-279",
          text: "Cariere",
          url: "https://uniprest.ro/despre-noi/cariere/"
        }
      ],
      id: "menu-item-3114",
      text: "Despre noi",
      url: "https://uniprest.ro/despre-noi/"
    },
    {
      id: "menu-item-4905",
      text: "Uniletter",
      url: "https://uniprest.ro/uniletter/"
    },
    {
      id: "menu-item-3343",
      text: "Blog",
      url: "https://uniprest.ro/blog/"
    }
  ],
  footerMenu: [
    {
      text: "Compania",
      children: [
        {
          id: "menu-item-10838",
          text: "Despre Uniprest Instal",
          url: "https://uniprest.ro/despre-noi/"
        },
        {
          id: "menu-item-9045",
          text: "Cui ne adresăm",
          url: "https://uniprest.ro/despre-noi/cui-ne-adresam/"
        },
        {
          id: "menu-item-5409",
          text: "Uniprest Instal Digital",
          url: "https://uniprest.ro/uniprest-instal-digital/"
        },
        {
          id: "menu-item-5405",
          text: "Evenimente",
          url: "https://uniprest.ro/evenimente/"
        },
        {
          id: "menu-item-5410",
          text: "Cariere",
          url: "https://uniprest.ro/despre-noi/cariere/"
        },
        {
          id: "menu-item-5406",
          text: "Implicare socială",
          url: "https://uniprest.ro/despre-noi/implicare-sociala/"
        },
        {
          id: "menu-item-5408",
          text: "În presă",
          url: "https://uniprest.ro/despre-noi/uniprest-instal-in-presa/"
        },
        {
          id: "menu-item-10839",
          text: "Partenerii noștri",
          url: "https://uniprest.ro/despre-noi/partenerii-nostri/"
        }
      ]
    },
    {
      text: "Oferta comercială",
      children: [
        {
          id: "menu-item-5419",
          text: "Servicii",
          url: "https://uniprest.ro/servicii/"
        },
        {
          id: "menu-item-5411",
          text: "Termice și încălzire",
          url: "https://uniprest.ro/categorii-de-produse/termice-incalzire/"
        },
        {
          id: "menu-item-5412",
          text: "Aer condiționat și ventilație",
          url: "https://uniprest.ro/categorii-de-produse/aer-conditionat-ventilatie/"
        },
        {
          id: "menu-item-5413",
          text: "Sanitare",
          url: "https://uniprest.ro/categorii-de-produse/sanitare/"
        },
        {
          id: "menu-item-5414",
          text: "Gaz",
          url: "https://uniprest.ro/categorii-de-produse/gaz/"
        },
        {
          id: "menu-item-5415",
          text: "Energie verde",
          url: "https://uniprest.ro/categorii-de-produse/energie-verde/"
        },
        {
          id: "menu-item-5416",
          text: "Apă",
          url: "https://uniprest.ro/categorii-de-produse/apa/"
        },
        {
          id: "menu-item-5417",
          text: "Promoții",
          url: "https://uniprest.ro/promotii/"
        },
        {
          id: "menu-item-5418",
          text: "Noutăți",
          url: "https://uniprest.ro/categorii-de-produse/noutati/"
        }
      ]
    },
    {
      text: "Informații legale",
      children: [
        {
          id: "menu-item-11851",
          text: "Termene și condiții",
          url: "https://uniprest.ro/termene-si-conditii/"
        },
        {
          id: "menu-item-5424",
          text: "Condiții contractuale",
          url: "https://uniprest.ro/conditii-contractuale-generale/"
        },
        {
          id: "menu-item-11852",
          text: "Garanție comercială",
          url: "https://uniprest.ro/garantie-comerciala/"
        },
        {
          id: "menu-item-11853",
          text: "Politica de cookies",
          url: "https://uniprest.ro/politica-de-cookies/"
        },
        {
          id: "menu-item-11854",
          text: "Prelucrarea datelor în scopuri de marketing",
          url: "https://uniprest.ro/prelucrarea-datelor-in-scopuri-de-marketing/"
        },
        {
          id: "menu-item-11855",
          text: "Prelucrarea și protecția datelor candidaților",
          url: "https://uniprest.ro/prelucrarea-si-protectia-datelor-candidatilor/"
        },
        {
          id: "menu-item-5427",
          text: "Sesizări încălcări ale legii (PDF)",
          url: "https://uniprest.ro/wp-content/uploads/2025/08/formular_de_raportare_privind_incalcari_ale_legii_uniprest.pdf"
        },
        {
          id: "menu-item-14511",
          text: "Declarație de accesibilitate",
          url: "https://uniprest.ro/declaratie-de-accesibilitate/"
        }
      ]
    },
    {
      text: "Comunitate",
      children: [
        {
          id: "menu-item-5428",
          text: "Install Efficiency",
          url: "https://uniprest.ro/evenimente/install-efficiency/"
        },
        {
          id: "menu-item-5429",
          text: "EXPO Uniprest",
          url: "https://uniprest.ro/evenimente/expo-uniprest/"
        },
        {
          id: "menu-item-5430",
          text: "Conversații-n Instalații",
          url: "https://uniprest.ro/evenimente/conversatii-n-instalatii/"
        },
        {
          id: "menu-item-5431",
          text: "Uniletter",
          url: "https://uniprest.ro/uniletter/"
        },
        {
          id: "menu-item-5432",
          text: "Blog",
          url: "https://uniprest.ro/blog/"
        },
        {
          id: "menu-item-5433",
          text: "Contact",
          url: "https://uniprest.ro/contact/"
        },
        {
          id: "menu-item-14504",
          text: "Feedback accesibilitate",
          url: "https://uniprest.ro/feedback-privind-accesibilitatea-site-ului/"
        }
      ]
    }
  ]
};
